import dayjs from "dayjs";
import { useDateSearchParamOrFallbackToToday } from "../../../hooks/useDateSearchParamOrFallbackToToday";

export function useIsWeekend() {
  const [selectedDate] = useDateSearchParamOrFallbackToToday();
  const dayName = dayjs.utc(selectedDate).format("dddd");
  const isWeekend = dayName === "Saturday" || dayName === "Sunday";
  return { dayName, isWeekend };
}
